export function loadRudderAnalyticsSdk(): Promise<
  typeof import('@rudderstack/analytics-js')
> {
  return import('@rudderstack/analytics-js')
}
